/* Copyright (c) 2021-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetResourcesByTagsLazyQuery } from "~/generated/graphql";
import { showError } from "~/services/toast";
import { Item, SelectionMethod } from "~/types";
import { mapResourcesToItems } from "~/views/resourceGroups/utils";

type Props = {
  onSuccess: (
    items?: Item[],
    pageInfo?: { count?: number; pages?: number }
  ) => void;
  onError?: () => void;
};

export function useGetResourcesByTags({ onSuccess, onError }: Props) {
  const [getResourcesByTags] = useGetResourcesByTagsLazyQuery({
    fetchPolicy: "cache-and-network",
    onCompleted: (response) => {
      const resourcesData = mapResourcesToItems(
        response?.resourcesByTags?.result ?? [],
        SelectionMethod.dynamic
      );
      onSuccess(
        resourcesData,
        response?.resourcesByTags?.pageInfo ?? undefined
      );
    },
    onError: (error) => {
      showError(error.message);
      onError?.();
    },
  });

  return {
    getResourcesByTags,
  };
}
